// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- 3rd Party
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import { ReportListItem, SurveySummaryModel } from '../../../models';
import { ReportModalComponent } from '../../report-modal/report-modal.component';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class ReportsBaseService {
  protected _reportsList$: BehaviorSubject<ReportListItem[]>;
  get reportsList$(): Observable<ReportListItem[]> {
    return this._reportsList$;
  }

  protected _reportIsLoading$: BehaviorSubject<boolean>;
  get reportIsLoading$(): Observable<boolean> {
    return this._reportIsLoading$;
  }

  protected _reportIsDownloading$: BehaviorSubject<boolean>;
  get reportIsDownloading$(): Observable<boolean> {
    return this._reportIsDownloading$;
  }

  constructor(protected modalService: NgbModal) {
    this._reportsList$ = new BehaviorSubject<ReportListItem[]>(null);
    this._reportIsLoading$ = new BehaviorSubject<boolean>(false);
    this._reportIsDownloading$ = new BehaviorSubject<boolean>(false);
  }

  protected _showReport(reportText: string) {
    const modalRef = this.modalService.open(ReportModalComponent, { centered: true });
    modalRef.componentInstance.reportText = reportText;
  }

  abstract loadReports(): void;
  abstract getReportOnline(identifier: string): void;
  abstract getReportPdf(identifier: string): void;
}
